;
define("store_locator_details.tpl", function(){});

